/*
  MX + ES text overrides for hardcoded strings that are not exposed in Translate & Adapt.
  Scope: text/label substitution only. No layout/style changes.
*/
(function () {
  'use strict';

  var TEXT_MAP = {
    'SHOP ALL': 'VER TODO',
    'SHOP THE PREVIEW': 'VER TODO',
    'SHOP OFFERS': 'VER PAQUETES',
    'CLEAN & RESTORE': 'LIMPIA Y RESTAURA',
    'PROTECT': 'PROTEJE',
    'STORE & DISPLAY': 'ALMACENA Y EXHIBE',
    'SHOP BY FABRIC': 'COMPRA POR MATERIAL',
    'CARE BY FABRIC TYPE': 'COMPRA POR MATERIAL',
    'PRE-TREATED LACES': 'AGUJETAS',
    'DEODERIZERS': 'DESODORANTES',
    'INSOLES': 'SUELAS',
    'Power [Exclusive Online]': 'Power (Exclusivo en linea)',
    'Sneaker Care Kits': 'Kits de limpieza y cuidado',
    'Cleaning Solutions': 'Soluciones de limpieza',
    'Wipes': 'Toallitas',
    'Mark On Pens': 'Mark On Marcadores',
    'Towels': 'Microfibras',
    'BAGS': 'MOCHILAS',
    'Sneaker Bag': 'MOCHILAS',
    'Protector Sprays & Bundles': 'Spray Protector y Paquetes',
    'Suede & Nubuck Kits': 'Kits de Gamuza & Nubuck',
    'Sneaker Protectors': 'Protectores de Tenis',
    'Conditioners': 'Acondicionadores',
    'VINYL CARE': 'VINIL',
    'LEATHER CARE': 'PIEL',
    'SUEDE & NUBUCK CARE': 'GAMUZA & NUBUCK',
    'PREMIUM & EXOTIC CARE': 'PREMIUM & EXOTICO',
    'MIXED MATERIAL CARE': 'MULTI MATERIALES',
    'CANVAS CARE': 'CANVAS',
    'SHOP FOAM MINI': 'COMPRA FOAM MINI',
    'SORT': 'FILTRAR',
    'Sort': 'Filtrar',
    'ADD TO CART': 'AGREGAR AL CARRITO',
    'ADD TO CART +': 'AGREGAR AL CARRITO',
    'NEWS': 'NOTICIAS',
    'COMPANY': 'COMPAÑÍA',
    'CUSTOMER SERVICE': 'SERVICIO AL CLIENTE',
    'MY ACCOUNT': 'MI CUENTA',
    'LANGUAGE': 'IDIOMA',
    'STAY UP TO DATE': 'MANTENTE ACTUALIZADO',
    'STAY CONNECTED': 'SIGUENOS EN REDES',
    'FREE SHIPPING': 'ENVÍO GRATIS',
    'Free shipping on orders above $50': 'Envío gratis en pedidos superiores a $899',
    'Free shipping on orders above £30': 'Envío gratis en pedidos superiores a $899',
    'Free shipping on orders above $30': 'Envío gratis en pedidos superiores a $899',
    'Free shipping for all US order': 'Envío gratis en pedidos superiores a $899',
    'Free Express Shipping On Orders Above $50': 'ENVÍO GRATIS EN PEDIDOS SUPERIORES A $899',
    '30 DAYS RETURN': '30 DÍAS DE DEVOLUCIÓN',
    'Simply return it within 30 days for an exchange or refund': 'Haz tu devolución dentro de 30 días para cambios o reembolso.',
    'You have 30 days to return': 'Haz tu devolución dentro de 30 días para cambios o reembolso.',
    'SUPPORT 24/7': 'CUIADAMOS TUS SNEAKERS/CUIDAMOS TUS ZAPATOS',
    '100% PAYMENT SECURE': 'EL HYPE ES REAL',
    'FOLLOW US @CREPPROTECT_MEX': 'SIGUENOS EN @CREPPROTECT_MEX',
    'Before You Go': '¿Olvidaste Algo?',
    'Befor You Go': '¿Olvidaste Algo?'
  };

  var ATTR_NAMES = ['data-default-label', 'data-selected-label', 'aria-label', 'title', 'value'];

  function normalize(str) {
    return (str || '').replace(/\s+/g, ' ').trim();
  }

  function translated(str) {
    var key = normalize(str);
    return Object.prototype.hasOwnProperty.call(TEXT_MAP, key) ? TEXT_MAP[key] : null;
  }

  function translateTextNode(node) {
    if (!node || node.nodeType !== 3) return false;
    var raw = node.nodeValue;
    if (!raw) return false;
    var replacement = translated(raw);
    if (!replacement) return false;
    var leading = (raw.match(/^\s*/) || [''])[0];
    var trailing = (raw.match(/\s*$/) || [''])[0];
    var next = leading + replacement + trailing;
    if (next === raw) return false;
    node.nodeValue = next;
    return true;
  }

  function isIgnoredNode(node) {
    if (!node || !node.parentElement) return true;
    var tag = node.parentElement.tagName;
    return tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA';
  }

  function translateTree(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (isIgnoredNode(n)) continue;
      translateTextNode(n);
    }
  }

  function translateAttributes(root) {
    if (!root || !root.querySelectorAll) return;
    for (var i = 0; i < ATTR_NAMES.length; i += 1) {
      var attrName = ATTR_NAMES[i];
      var nodes = root.querySelectorAll('[' + attrName + ']');
      for (var j = 0; j < nodes.length; j += 1) {
        var el = nodes[j];
        var current = el.getAttribute(attrName);
        if (!current) continue;
        var next = translated(current);
        if (next && next !== current) {
          el.setAttribute(attrName, next);
          if (attrName === 'value' && ('value' in el)) {
            el.value = next;
          }
        }
      }
    }
  }

  function forceSelectorText() {
    var map = [
      ['.cp-dnav__item:first-child .cp-dnav__toplink span', 'VER TODO'],
      ['.cp-dnav__item--offers .cp-dnav__toplink span', 'VER PAQUETES'],
      ['.cp-dnav__l2-link[data-group-trigger="clean"]', 'LIMPIA Y RESTAURA'],
      ['.cp-dnav__l2-link[data-group-trigger="protect"]', 'PROTEJE'],
      ['.cp-dnav__l2-link[data-group-trigger="store"]', 'ALMACENA Y EXHIBE'],
      ['.cp-dnav__l2-link[data-group-trigger="fabric"]', 'COMPRA POR MATERIAL'],
      ['.cp-dnav__l2-link[data-group-trigger="laces"]', 'AGUJETAS'],
      ['.cp-dnav__l2-link[data-group-trigger="deoderizers"]', 'DESODORANTES'],
      ['.cp-dnav__l2-link[data-group-trigger="insoles"]', 'SUELAS'],
      ['.cp-dnav__l3-panel[data-group-panel="clean"] a[href="/products/power"]', 'Power (Exclusivo en linea)'],
      ['.cp-dnav__l3-panel[data-group-panel="clean"] a[href="/collections/sneaker-care-kits"]', 'Kits de limpieza y cuidado'],
      ['.cp-dnav__l3-panel[data-group-panel="clean"] a[href="/collections/cleaning-solutions"]', 'Soluciones de limpieza'],
      ['.cp-dnav__l3-panel[data-group-panel="clean"] a[href="/collections/wipes"]', 'Toallitas'],
      ['.cp-dnav__l3-panel[data-group-panel="clean"] a[href="/collections/paint-pens"]', 'Mark On Marcadores'],
      ['.cp-dnav__l3-panel[data-group-panel="clean"] a[href="/collections/towels"]', 'Microfibras'],
      ['.cp-dnav__l3-panel[data-group-panel="protect"] a[href="/collections/protector-sprays"]', 'Spray Protector y Paquetes'],
      ['.cp-dnav__l3-panel[data-group-panel="protect"] a[href="/collections/suede-nubuck-care"]', 'Kits de Gamuza & Nubuck'],
      ['.cp-dnav__l3-panel[data-group-panel="protect"] a[href="/collections/sneaker-protectors"]', 'Protectores de Tenis'],
      ['.cp-dnav__l3-panel[data-group-panel="protect"] a[href="/collections/sneaker-conditioner"]', 'Acondicionadores'],
      ['.cp-dnav__fabric-grid-item--vinyl .cp-dnav__fabric-item-label', 'VINIL'],
      ['.cp-dnav__fabric-grid-item--leather .cp-dnav__fabric-item-label', 'PIEL'],
      ['.cp-dnav__fabric-grid-item--suede .cp-dnav__fabric-item-label', 'GAMUZA & NUBUCK'],
      ['.cp-dnav__fabric-grid-item--premium .cp-dnav__fabric-item-label', 'PREMIUM & EXOTICO'],
      ['.cp-dnav__fabric-grid-item--mixed .cp-dnav__fabric-item-label', 'MULTI MATERIALES'],
      ['.cp-dnav__fabric-grid-item--canvas .cp-dnav__fabric-item-label', 'CANVAS'],
      ['.cp-dnav__right-feature-card[data-right-feature-card="clean"] .cp-dnav__right-feature-cta', 'COMPRA FOAM MINI'],
      ['.cp-home-shipping-text', 'ENVÍO GRATIS EN PEDIDOS SUPERIORES A $899'],
      ['.cp-spice-collection__sort-label', 'Filtrar']
    ];
    for (var i = 0; i < map.length; i += 1) {
      var selector = map[i][0];
      var value = map[i][1];
      var els = document.querySelectorAll(selector);
      for (var j = 0; j < els.length; j += 1) {
        if (normalize(els[j].textContent) !== value) {
          els[j].textContent = value;
        }
      }
    }
  }

  function runPass(root) {
    translateAttributes(root || document);
    translateTree(root || document.body || document.documentElement);
    forceSelectorText();
  }

  var rafId = null;
  function scheduleRun() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      runPass(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runPass(document);
    });
  } else {
    runPass(document);
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = false;
    for (var i = 0; i < mutations.length; i += 1) {
      if (mutations[i].type === 'childList' || mutations[i].type === 'characterData') {
        shouldRun = true;
        break;
      }
    }
    if (shouldRun) scheduleRun();
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
})();
